<template>
  <div>
    <a-input
      showSearch
      :title="title"
      labelInValue
      :placeholder="placeholder"
      style="width: 80%"
      :value="selectedValue"
      @dblclick="e => handleSearch()"
      @change="handleChange"
    >
    </a-input>
    <dynamic-modal
      ref="dynModal" 
      :title="title" 
      :placeholder="placeholder" 
      :queryId="parameter.id" 
      :parameter="searchParam" 
      @rowDblClick="rowDblClick">
    </dynamic-modal>
  </div>
</template>
<script>
  import DynamicModal from './DynamicModal'
  import { objToStrMap } from '@/utils/util'
  import Vue from 'vue'
  import { OPERATOR, WAREHOUSE } from '@/store/mutation-types'
  export default {
    name: 'ModalSelector',
    components: {
      DynamicModal
    },
    data() {
      return {
        selectedValue:'',
        allowClear: true,
        data: [],
        record: {},
        searchParam: {
          warehouse: Vue.ls.get(WAREHOUSE),
          qry: true,
          executor: Vue.ls.get(OPERATOR),
          'query.no': this.parameter.no,
          args: this.parameter.args?this.parameter.args:{}
        }
      }
    },
    props: {
      'placeholder':{
        type: String,
        default:null
      },
      'parameter':{
        type:Object,
        default:null
      },
      'title':{
        type:String,
        default: null
      },
      'targetField': {
        type: String,
        default: null
      },
      'paramName':{
        type: String,
        default: ''
      },
      'value':{
        type: String,
        default: ''
      }
    },
    watch: {
      value: function () {
        this.selectedValue = this.value
      }
    },
    mounted() {
      //this.init()
      //this.$emit('getData')
    },
    methods: {
      rowDblClick(record) {
        this.record = record
        this.selectedValue = objToStrMap(this.record).get(this.targetField)
        this.$emit('change', this.selectedValue)
      },
      handleSearch() {
          this.$refs.dynModal.open()
      },
      handleChange(val){
        this.$emit('change', val)
      }
    }
  }
</script>
